import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Content } from 'pdfmake/interfaces';
import { FlightBooking } from '@pages/common-order/_interfaces_/flight-booking.interface';

@Injectable({
  providedIn: 'root',
})
export class BundledFarePdfService {
  constructor(private translateService: TranslateService) {}

  public getContent(flightBookings?: FlightBooking[]): Content[] {
    if (flightBookings[0]?.bundleFares[0]?.includedServices && flightBookings[0]?.bundleFares[0]?.includedServices.length > 0) {
      const content = [{ text: this.translateService.instant('PRINT.BUNDLED_FARE'), style: 'subheader2' }];
      flightBookings[0]?.bundleFares[0]?.includedServices.forEach((service) => {
        const serviceText = service.charAt(0).toUpperCase() + service.slice(1);
        content.push({ text: `\n${serviceText}`, style: 'textLine' });
      });
      content.push({ text: '\n\n\n', style: '' });

      return content;
    }

    return null;
  }
}
